module.exports = __webpack_public_path__ + "img/m5.b7c8949a.jpg";